<template>
    <el-dialog
        class="edit-coupon"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Edit Coupon"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="editForm"
                :model="editForm"
                :rules="rules"
                label-width="80px"
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Time" prop="time" size="small">
                            <el-date-picker
                                v-model="editForm.time"
                                type="datetimerange"
                                range-separator="-"
                                start-placeholder="Start Time"
                                end-placeholder="End Time"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="Title" prop="name" size="small">
                            <el-input
                                v-model="editForm.name"
                                placeholder="Please input name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Discount" prop="value" size="small">
                            <el-input
                                v-model="editForm.value"
                                placeholder="Please input value"
                                ><template slot="append">% off</template></el-input
                            >
                        </el-form-item>
                        <el-form-item label="Desc" prop="desc" size="small">
                            <el-input
                                type="textarea"
                                v-model="editForm.desc"
                                placeholder="Please input desc"
                                :autosize="{ minRows: 4, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            editForm: {
                name: "",
                value: "",
                time: [],
                desc: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                value: [
                    {
                        required: true,
                        message: "Please input ioss",
                    },
                ],
                time: [
                    {
                        required: true,
                        message: "Please select time",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.editForm = {
                name: "",
                value: "",
                time: [],
                desc: "",
            }
            this.$refs["editForm"].clearValidate();
            this.$refs["editForm"].resetFields();
            this.$emit("update:editVisible", false);
        },
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    let time = JSON.parse(JSON.stringify(this.editForm.time));
                    delete this.editForm.time;
                    cmofferApi
                        .couponList(
                            {
                                ...this.editForm,
                                start_time: time[0],
                                end_time: time[1],
                            },
                            "post",
                            this.tableItem.id
                        )
                        .then((res) => {
                            if (res) {
                                this.$message.success(
                                    this.$i18n.locale == "zh"
                                        ? "编辑成功"
                                        : "Success"
                                );
                                this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                            }
                        });
                }
            });
        },
        couponList() {
            cmofferApi
                .couponList({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.editForm = { ...res.data, time: [res.data.start_time, res.data.end_time] };
                    }
                })
                .catch(() => {});
        },
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        editVisible(val) {
            if(val){
                this.couponList();
            }
        },
    },
    computed:{
        ...mapState({
            pickerOptions: state => state.index.pickerOptions
        })
    }
};
</script>
<style lang="scss" scoped>
.edit-coupon {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
